<template>
  <div>
    <material-card
      color="Cyan"
      :title="`Faturas > ${
        typeof buyer.name === 'undefined' ? '' : buyer.name
      }`"
      text=""
    >
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        :loading="true"
        no-data-text="Não há faturas para esse membro"
        v-if="!loading && items.length > 0"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading text-xs-right font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td @click="editInvoice(item.item)">
            {{ item.item.competence | formatarData }}
          </td>
          <td class="text-xs-right">
            R$ {{ item.item.amount | formatCurrency }}
          </td>
          <td class="text-xs-right">
            R$ {{ item.item.total | formatCurrency }}
          </td>
          <td class="text-xs-right">
            R$ {{ item.item.discount | formatCurrency }}
          </td>
          <td class="text-xs-right">
            <v-icon v-if="item.item.status !== 'paga'">{{
              item.item.status | formatStatus
            }}</v-icon>
            <v-icon color="primary" v-if="item.item.status === 'paga'">{{
              item.item.status | formatStatus
            }}</v-icon>
          </td>
          <td class="text-xs-center">
            <v-icon
              @click="
                enviarEmail(
                  buyer,
                  item.item,
                  email_template,
                  buyer.payment_type,
                )
              "
              >email</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="!item.item.bill_url">
            <v-icon @click="invoiceSelected(item.item, buyer.customer_id)"
              >cloud_upload</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="item.item.bill_url">
            <v-icon @click="showBill(item.item)" color="success"
              >cloud_download</v-icon
            >
          </td>
          <td class="text-xs-right">
            <!--
                    <v-btn 
                    color="success" 
                    v-if="item.item.transaction_status !== 'succeeded'" 
                    @click="faturar(buyer, buyer.buyer_id, item.item)"
                    :loading="loading_faturar"
                    :disabled="loading_faturar"
                    >
                    {{item.item.transaction_status === 'pending'?'refaturar':'faturar'}}
                    </v-btn>
                    -->
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-if="item.item.transaction.status !== 'succeeded'"
                  :loading="loading_faturar"
                  :disabled="loading_faturar"
                  >monetization_on</v-icon
                >
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item_faturar, i) in items_faturar"
                  :key="i"
                  @click="
                    faturar(buyer, buyer.buyer_id, item.item, item_faturar.type)
                  "
                >
                  <v-list-tile-title>{{
                    item_faturar.title
                  }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          <!-- <td class="text-xs-right"><v-icon color="blue-grey darken-2">edit</v-icon>&nbsp;<v-icon color="red darken-2">delete</v-icon></td> -->
        </template>
      </v-data-table>
      <template v-if="!loading && items.length <= 0" justify-center>
        <v-card-text>
          <p class="text-md-center">Não há faturas cadastradas</p>
        </v-card-text>
      </template>
      <v-progress-linear
        v-if="loading"
        height="2"
        v-slot:loading
        color="cyan"
        indeterminate
      ></v-progress-linear>
    </material-card>
  </div>
</template>
<script>
import moment from "moment";
import { eventBus } from "../../main";

export default {
  props: ["items", "buyer"],
  data: () => ({
    loading: false,
    loading_faturar: false,
    invoice: {},
    headers: [
      {
        sortable: false,
        text: "Competencia",
        value: "competence",
      },
      {
        sortable: false,
        text: "Créditos",
        value: "amount",
      },
      {
        sortable: false,
        text: "Mensalidade",
        value: "total",
      },
      {
        sortable: false,
        text: "Economia",
        value: "discount",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
      {
        sortable: false,
        text: "",
        value: "enviaEmail",
      },
      {
        sortable: false,
        text: " ",
        value: "faturar",
      },
    ],
    items_faturar: [
      {
        title: "Cartão de Crédito",
        type: "credit",
      },
      {
        title: "Boleto",
        type: "boleto",
      },
    ],
  }),
  methods: {
    invoiceSelected(invoice, customer_id) {
      eventBus.$emit("invoiceSelected", invoice);
      eventBus.$emit("customer_id", customer_id);
    },
    showBill(invoice) {
      eventBus.$emit("showBill", invoice);
    },
    faturar(invoice) {
      eventBus.$emit("faturar", invoice);
    },
  },

  filters: {
    formatarData: function (value) {
      if (!value) return "";
      let timestamp = value; // firebase data
      let myDate = new Date();
      if (timestamp._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        myDate = new Date(timestamp); // date object
      }

      return moment(myDate.toISOString().substr(0, 10)).format("MM/YYYY");
    },
    formatStatus: function (value) {
      if (!value) return "";
      if (value === "paga") {
        return "done_outline";
      } else if (value === "aberta") {
        return "schedule";
      } else {
        return "error";
      }
    },
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
